import { all_routes } from "../../../feature-module/router/all_routes";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

const route = all_routes;

// Define a type for the decoded token
interface DecodedToken {
  role_id: number;
  [key: string]: any;
}

// SidebarData with conditional logic
export const SidebarData = (roleId?: number) => {
  // Define Leads Management submenu items
  const leadsManagementSubmenuItems =
    roleId === 5
      ? [
          { label: "Quick Leads", link: route.repAddQuickLeads },
          { label: "My Leads", link: route.myLeads },
        ]
      : roleId === 4
      ? [
          { label: "Quick Leads", link: route.addQuickLeads },
          { label: "All Leads", link: route.viewAllLeads },
          { label: "My Leads", link: route.myLeads },
        ]
      : [
          { label: "Leads Dashboard", link: route.leadsDashboard },
          { label: "Quick Leads", link: route.addQuickLeads },
          { label: "All Leads", link: route.viewAllLeads },
          { label: "My Leads", link: route.myLeads },
        ];

  // Define Contact Management submenu items
  const contactManagementSubmenuItems =
    roleId === 4
      ? [{ label: "My Call History", link: route.myCallHistory }]
      : [
          { label: "Call Dashboard", link: route.CallDashBoard },
          { label: "Call History", link: route.callHistory },
          { label: "My Call History", link: route.myCallHistory },
        ];

  // Define Campaign Management submenu items
  const campaignManagementSubmenuItems =
    roleId === 4
      ? [
          { label: "Campaigns", link: route.campaign },
          { label: "Assigned Channels", link: route.assignedChannels },
        ]
      : roleId === 3
      ? [{ label: "Campaigns", link: route.campaign }] // Only Campaigns for roleId 3
      : [
          { label: "Campaign Dashboard", link: route.CampaignDashboard },
          { label: "Campaigns", link: route.campaign },
          { label: "Assigned Channels", link: route.assignedChannels },
        ];

  // Define Budget Management submenu items
  const budgetManagementSubmenuItems =
    roleId === 3
      ? [{ label: "Annual Budget", link: route.createBudget }] // All of Budget Management
      : [{ label: "Annual Budget", link: route.createBudget }];

  // Define Settings submenu items
  const settingsSubmenuItems =
    roleId === 4
      ? [
          { label: "Beneficiary", link: route.stakeholderList },
          { label: "Representative", link: route.representativeList },
        ]
      : roleId === 3
      ? [
          // Specific settings for roleId 3
          { label: "Budget Approval", link: route.ApproveBudget },
          { label: "Campaign Approval", link: route.campaignApproval },
          { label: "Sub-Budget Approval", link: route.subBudgetApproval },
          {
            label: "Sub-Budget Fund Approval",
            link: route.subBudgetFundApproval,
          },
        ]
      : [
          { label: "Lead Assign", link: route.leadAssign },
          { label: "Budget Approval", link: route.ApproveBudget },
          { label: "Campaign Approval", link: route.campaignApproval },
          {
            label: "Campaign Top-Up Approval",
            link: route.campaignTopupApproval,
          },
          { label: "Sub-Budget Approval", link: route.subBudgetApproval },
          {
            label: "Sub-Budget Fund Approval",
            link: route.subBudgetFundApproval,
          },
          { label: "Beneficiary", link: route.stakeholderList },
          { label: "Representative", link: route.representativeList },
        ];

  // Base structure for roleId === 5
  const baseMenu = [
    {
      label: "MAIN MENU",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Leads Management",
          icon: "ti ti-chart-arcs",
          submenu: true,
          showSubRoute: false,
          submenuItems: leadsManagementSubmenuItems,
        },
      ],
    },
  ];

  // Structure for roleId === 4
  const roleFourMenu = [
    {
      label: "MAIN MENU",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Leads Management",
          icon: "ti ti-chart-arcs",
          submenu: true,
          showSubRoute: false,
          submenuItems: leadsManagementSubmenuItems,
        },
        {
          label: "Contact Management",
          icon: "ti ti-user-up",
          submenu: true,
          showSubRoute: false,
          submenuItems: contactManagementSubmenuItems,
        },
        {
          label: "Campaign Management",
          icon: "ti ti-brand-campaignmonitor",
          submenu: true,
          showSubRoute: false,
          submenuItems: campaignManagementSubmenuItems,
        },
        {
          label: "Budget Management",
          icon: "ti ti-file-invoice",
          submenu: true,
          showSubRoute: false,
          submenuItems: budgetManagementSubmenuItems,
        },
        {
          label: "Settings",
          icon: "ti ti-settings-cog",
          submenu: true,
          showSubRoute: false,
          submenuItems: settingsSubmenuItems,
        },
      ],
    },
  ];

  // Structure for roleId === 3
  const roleThreeMenu = [
    {
      label: "MAIN MENU",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Campaign Management",
          icon: "ti ti-brand-campaignmonitor",
          submenu: true,
          showSubRoute: false,
          submenuItems: campaignManagementSubmenuItems,
        },
        {
          label: "Budget Management",
          icon: "ti ti-file-invoice",
          submenu: true,
          showSubRoute: false,
          submenuItems: budgetManagementSubmenuItems,
        },
        {
          label: "Settings",
          icon: "ti ti-settings-cog",
          submenu: true,
          showSubRoute: false,
          submenuItems: settingsSubmenuItems,
        },
      ],
    },
  ];

  // Full structure for other roleIds
  const fullMenu = [
    {
      label: "MAIN MENU",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: "Leads Management",
          icon: "ti ti-chart-arcs",
          submenu: true,
          showSubRoute: false,
          submenuItems: leadsManagementSubmenuItems,
        },
        {
          label: "Contact Management",
          icon: "ti ti-user-up",
          submenu: true,
          showSubRoute: false,
          submenuItems: contactManagementSubmenuItems,
        },
        {
          label: "Campaign Management",
          icon: "ti ti-brand-campaignmonitor",
          submenu: true,
          showSubRoute: false,
          submenuItems: campaignManagementSubmenuItems,
        },
        {
          label: "Budget Management",
          icon: "ti ti-file-invoice",
          submenu: true,
          showSubRoute: false,
          submenuItems: budgetManagementSubmenuItems,
        },
        {
          label: "Settings",
          icon: "ti ti-settings-cog",
          submenu: true,
          showSubRoute: false,
          submenuItems: settingsSubmenuItems,
        },
      ],
    },
  ];

  // Return appropriate menu based on roleId
  if (roleId === 5) return baseMenu;
  if (roleId === 4) return roleFourMenu;
  if (roleId === 3) return roleThreeMenu; // Return roleThreeMenu for roleId 3
  return fullMenu;
};

// Example usage in a component
const MyComponent = () => {
  const [roleId, setRoleId] = useState<number | undefined>(undefined);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      setRoleId(decodedToken.role_id); // Set the role_id in state
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  const sidebarData = SidebarData(roleId); // Pass roleId to SidebarData

  return <div>{/* Use sidebarData here */}</div>;
};
